export default "__VITE_PUBLIC_ASSET__6bebaa58__"